import { render, staticRenderFns } from "./TableWithFrontPaginationDesign.vue?vue&type=template&id=2180ceb7&"
import script from "./TableWithFrontPaginationDesign.vue?vue&type=script&lang=ts&"
export * from "./TableWithFrontPaginationDesign.vue?vue&type=script&lang=ts&"
import style0 from "./TableWithFrontPaginationDesign.vue?vue&type=style&index=0&id=2180ceb7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports